import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { CalcType } from "../../enums";

interface Props {
  type: CalcType;
  style?: React.CSSProperties;
}

export const CalcTypeTag = ({ type, style }: Props) => {
  const { t } = useTranslation();

  let color: string;

  switch (type) {
    case CalcType.MTPL:
      color = PresetColors.GREEN;
      break;
    case CalcType.CRASH:
      color = PresetColors.GEEKBLUE;
      break;
    case CalcType.MTPL_CRASH:
      color = PresetColors.CYAN;
      break;
    case CalcType.GAP:
      color = PresetColors.PURPLE;
      break;
    case CalcType.PAS:
      color = PresetColors.VOLCANO;
      break;
    case CalcType.REALTY:
      color = PresetColors.RED;
      break;
    case CalcType.TRAVEL:
      color = PresetColors.ORANGE;
      break;
  }

  return (
    <Tag color={color} style={style}>
      {t("calc.enums.calcType." + type)}
    </Tag>
  );
};
